import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Activities() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/activities").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="activities-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-[#C24D2C]">Extension</p>
        <h1 className="mt-4 font-serif-display text-5xl lg:text-6xl text-[#1A2456] font-bold max-w-4xl">
          Fieldwork across <span className="italic text-[#E35D29]">Madhya Pradesh.</span>
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-[#5C544F] leading-relaxed">
          Workshops, training programmes, awareness camps and participatory events I have led or contributed to.
        </p>

        {loading ? (
          <p className="mt-16 text-[#8A817C]">Loading activities…</p>
        ) : items.length === 0 ? (
          <p className="mt-16 text-[#8A817C] italic">No activities added yet.</p>
        ) : (
          <div className="mt-16 space-y-8">
            {items.map((a, idx) => (
              <article
                key={a.id}
                data-testid={`activity-${a.id}`}
                className={`grid md:grid-cols-12 gap-8 items-start border-b border-[#D8CFC4] pb-10 ${
                  idx % 2 === 1 ? "md:flex-row-reverse" : ""
                }`}
              >
                {a.image_url && (
                  <div className="md:col-span-5">
                    <img src={a.image_url} alt={a.title} className="w-full aspect-[4/3] object-cover" />
                  </div>
                )}
                <div className={a.image_url ? "md:col-span-7" : "md:col-span-12"}>
                  {a.date && (
                    <p className="text-[10px] tracking-[0.3em] uppercase text-[#C24D2C]">{a.date}</p>
                  )}
                  <h2 className="mt-2 font-serif-display text-3xl text-[#1A2456]">{a.title}</h2>
                  {a.location && (
                    <p className="mt-2 text-sm text-[#8A817C]">📍 {a.location}</p>
                  )}
                  <p className="mt-4 text-[#5C544F] leading-relaxed">{a.description}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
